package org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class CashRegisterGlobalModel(
    @SerialName("data")
    val data: Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)